import { inject, Type } from '@angular/core'
import { ResolveFn } from '@angular/router'
import { RedirectorService } from 'src/app/service/redirector.service'

export const buyComponentResolver: ResolveFn<Type<any> | null> = () => {
  const context = inject(RedirectorService).getContext()
  const key = `${context.config.type}-${context.config.template}`

  const loaders: Record<string, () => Promise<Type<any>>> = {
    'error-setup': () => import('src/app/buy-page/error/error-setup/error-setup.component').then(m => m.ErrorSetupComponent),
    'error-argp': () => import('src/app/buy-page/error/error-argp/error-argp.component').then(m => m.ErrorArgpComponent),
    'paynow-sicherheit': () => import('src/app/buy-page/paynow/paynow-sicherheit/paynow-sicherheit.component').then(m => m.PaynowSicherheitComponent),
    'paynow-vertrieb': () => import('src/app/buy-page/paynow/paynow-vertrieb/paynow-vertrieb.component').then(m => m.PaynowVertriebComponent),
    'paynow-sold': () => import('src/app/buy-page/paynow/paynow-sold/paynow-sold.component').then(m => m.PaynowSoldComponent),
    'paynow-slim': () => import('src/app/buy-page/paynow/paynow-slim/paynow-slim.component').then(m => m.PaynowSlimComponent),
    '4sale-smart': () => import('src/app/buy-page/forsale/forsale-smart/forsale-smart.component').then(m => m.ForsaleSmartComponent),
    '4sale-expert': () => import('src/app/buy-page/forsale/forsale-expert/forsale-expert.component').then(m => m.ForsaleExpertComponent),
    '4sale-default': () => import('src/app/buy-page/forsale/forsale-default/forsale-default.component').then(m => m.ForsaleDefaultComponent),
    'landing-recently-caught': () => import('src/app/pages/landing/domain-catch/domain-catch.component').then(m => m.DomainCatchComponent),
  }

  const loader = loaders[key]

  if (!loader) {
    return null
  }

  return loader().catch(err => {
    console.error(`Failed to load buy component for key "${key}":`, err)
    return null
  })
}